export const ROLES = {
  STUDENT: 0,
  FACULTY: 1,
  ADMIN: 2
};
